import { takeEvery } from 'redux-saga/effects';
import { load, loadById, loadSet, update } from 'sdk/biller';
import { LOAD, LOAD_ID, LOAD_SET, UPDATE } from 'model/biller';
import { callAction, ORM } from '../util';

export default function* saga() {
  yield takeEvery(
    LOAD.ACTION,
    callAction({
      api: load,
      dataName: ORM,
      type: LOAD,
    })
  );

  yield takeEvery(
    LOAD_ID.ACTION,
    callAction({
      api: loadById,
      dataName: ORM,
      type: LOAD_ID,
    })
  );

  yield takeEvery(
    LOAD_SET.ACTION,
    callAction({
      api: loadSet,
      dataName: ORM,
      type: LOAD_SET,
    })
  );

  yield takeEvery(
    UPDATE.ACTION,
    callAction({
      api: update,
      dataName: ORM,
      type: UPDATE,
      formatSuccessMessage: () => 'Biller was updated successfully',
    })
  );
}
